import styled from "styled-components";

// LAYOUT GENERAL
export const Page = styled.div`
  // padding: 18px;
  display: flex;
  gap: 18px;
  box-sizing: border-box;
  height: calc(100vh - 148px); 
`;


// COLUMNA IZQUIERDA (ROLES)
export const Left = styled.div`
  flex: 0 0 280px;     /* ancho base */
  max-width: 320px;    /* no crecer demasiado */
  min-width: 240px;    /* no romper diseño */
  background: var(--color-surface-base);
  border-radius: var(--radius-md);
  padding: 16px;
  box-shadow: var(--shadow-sm);
  border: var(--border-subtle);
  display: flex;
  flex-direction: column;

  @media (max-width: 1000px) {
    flex: 0 0 220px;
  }

  @media (max-width: 800px) {
    display: none; /* opcional: esconder menú en móviles */
  }
`;


// COLUMNA DERECHA (TREE)
export const Right = styled.div`
  flex: 1;              /* OBLIGATORIO para responsividad */
  min-width: 0;         /* evita overflow */
  background: var(--color-surface-base);
  border-radius: var(--radius-md);
  padding: 24px;
  box-shadow: var(--shadow-sm);
  border: var(--border-subtle);
  display: flex;
  flex-direction: column;
`;


// UI ELEMENTOS
export const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RoleListContainer = styled.div`
  margin-top: 10px;
  flex: 1;
  overflow-y: auto;
`;

export const RoleItem = styled.div`
  display: flex;
  flex-direction: row;  
  justify-content: space-between;
  padding: 2px 12px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  background: ${(p) => (p.active ? "var(--color-accent-soft)" : "transparent")};
  color: ${(p) => (p.active ? "var(--color-accent)" : "var(--color-text-title)")};
  margin-bottom: 4px;
  transition: all 0.2s ease;
  font-weight: ${(p) => (p.active ? "500" : "400")};

  &:hover {
    background: var(--color-surface-hover);
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: var(--radius-sm);
  border: var(--border-medium);
  font-size: 14px;
  font-family: var(--font-body);
  transition: border-color 0.2s, box-shadow 0.2s;
  outline: none;

  &:focus {
    border-color: var(--color-accent);
    box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.1);
  }
`;

export const TreeHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// contenedor del arbol
export const TreeContainer = styled.div`
  max-height: calc(100vh - 220px);
  overflow: auto;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
`;

// --- FORM & UI ELEMENTS (PREMIUM) ---

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 16px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 16px;
  position: relative;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-title);
  font-family: var(--font-display);
  display: flex;
  align-items: center;
  gap: 4px;

  &::after {
    content: "${(props) => (props.required ? "*" : "")}";
    color: #ef4444;
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 14px;
  border-radius: var(--radius-md);
  border: var(--border-medium);
  font-size: 14px;
  font-family: var(--font-body);
  background: ${(props) => (props.readOnly ? "var(--color-surface-muted)" : "var(--color-surface-base)")};
  color: var(--color-text-body);
  transition: all 0.2s ease;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: var(--color-accent);
    box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.1);
  }

  &::placeholder {
    color: var(--color-text-muted);
    opacity: 0.6;
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px 14px;
  border-radius: var(--radius-md);
  border: var(--border-medium);
  font-size: 14px;
  font-family: var(--font-body);
  background: var(--color-surface-base);
  color: var(--color-text-body);
  transition: all 0.2s ease;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  padding-right: 40px;

  &:focus {
    border-color: var(--color-accent);
    box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.1);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px 14px;
  border-radius: var(--radius-md);
  border: var(--border-medium);
  font-size: 14px;
  font-family: var(--font-body);
  background: var(--color-surface-base);
  color: var(--color-text-body);
  transition: all 0.2s ease;
  outline: none;
  resize: vertical;
  min-height: 120px;
  box-sizing: border-box;

  &:focus {
    border-color: var(--color-accent);
    box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.1);
  }
`;

export const SectionTitle = styled.h4`
  font-family: var(--font-display);
  font-size: 16px;
  font-weight: 700;
  color: var(--color-text-title);
  margin: 32px 0 16px 0;
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 18px;
    background: var(--color-accent);
    border-radius: 4px;
  }
`;

// TABLE SYSTEM
export const TableContainer = styled.div`
  width: 100%;
  overflow: hidden;
  border-radius: var(--radius-md);
  border: var(--border-subtle);
  background: var(--color-surface-base);
  box-shadow: var(--shadow-sm);
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  text-align: left;
`;

export const Th = styled.th`
  padding: 12px 16px;
  background: var(--color-surface-muted);
  color: var(--color-text-muted);
  font-weight: 600;
  text-transform: uppercase;
  font-size: 11px;
  letter-spacing: 0.05em;
  border-bottom: var(--border-medium);
`;

export const Td = styled.td`
  padding: 14px 16px;
  color: var(--color-text-body);
  border-bottom: var(--border-subtle);
  vertical-align: middle;
`;

export const Tr = styled.tr`
  transition: background 0.2s;
  &:hover {
    background: var(--color-surface-hover);
  }
  &:last-child td {
    border-bottom: none;
  }
`;
